import {createUseStyles} from 'react-jss'
import {AmlReportModel} from '../../redux/companyMonitorTypes';
import {faFileShield} from "@fortawesome/free-solid-svg-icons";
import {useState} from "react";
import ReportModal from "./ReportModal";
import ComplianceBadge from "./ComplianceBadge";
import CompanyReportInfoCard from "./CompanyReportInfoCard";

interface Props {
  amlReport: AmlReportModel
}

const CompanyReportAmlReportCard = ({amlReport}: Props) => {
  const styles = useStyles()
  const [reportModalVisible, setReportModalVisible] = useState(false)

  return (
    <>
      <CompanyReportInfoCard
        title='Company AML report'
        icon={faFileShield}
        flagged={amlReport.isSanction}
        onClick={() => setReportModalVisible(true)}
        sources={['Pliance']}>
        {/* PEP and RCA are only applicable to the representatives, not to the company itself. */}
        <div className={styles.badgeContainer}>
          <ComplianceBadge
            flagged={amlReport.isSanction}
            flaggedLabel='Sanctioned'
            compliantLabel='Not sanctioned'
          />
        </div>
      </CompanyReportInfoCard>

      <ReportModal
        title='Company AML report'
        visible={reportModalVisible}
        reportContent={amlReport.report}
        onCloseClick={() => setReportModalVisible(false)}
      />
    </>
  )
}
export default CompanyReportAmlReportCard

const useStyles = createUseStyles({
  badgeContainer: {
    // Keeps the badges at the bottom when the card is stretched by a taller sibling.
    marginTop: 'auto',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    fontFamily: 'Aestetico-Regular',
    fontSize: "large"
  }
})
